const JUST_PAID_FLAG_KEY = 'just_paid_flag';

export async function setJustPaidFlag(): Promise<void> {
  try {
    localStorage.setItem(JUST_PAID_FLAG_KEY, 'true');
  } catch (error) {
    console.error('Error setting just paid flag:', error);
  }
}

export function clearJustPaidFlag(): void {
  try {
    localStorage.removeItem(JUST_PAID_FLAG_KEY);
  } catch (error) {
    console.error('Error clearing just paid flag:', error);
  }
}

export function getJustPaidFlag(): boolean {
  try {
    return localStorage.getItem(JUST_PAID_FLAG_KEY) === 'true';
  } catch (error) {
    console.error('Error getting just paid flag:', error);
    return false;
  }
}
